import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as requestInitialState,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'health-board',
  'patient-portal-activity-log',
  ['LOAD_MORE'],
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'ccd',
    'activity_logs',
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
});

const initialState = {
  ...requestInitialState,
  list: [],
  offset: 0,
  isLastPage: false,
};

const requestReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.SEND:
      return {
        ...state,
        succeed: false,
        sending: true,
        offset: payload && payload.offset,
      };
    case consts.SUCCEED:
      return {
        ...state,
        succeed: true,
        sending: false,
        isLastPage: payload && !payload.length,
        list:
          state.list && state.list.length !== 0
            ? state.list.concat(payload)
            : payload,
      };
    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/patientPortal/activity-log-req.js